import { render, staticRenderFns } from "./PlushieAddTagForm.vue?vue&type=template&id=45c1d8cc&scoped=true&"
import script from "./PlushieAddTagForm.vue?vue&type=script&lang=ts&"
export * from "./PlushieAddTagForm.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieAddTagForm.vue?vue&type=style&index=0&id=45c1d8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1d8cc",
  null
  
)

export default component.exports